import TransactionLogger from '../actions/transactionLogger';
import {
  ENTITY_TYPE_PROJECT_INSURED,
} from '../../../../lib/appConstants';

export const mapProjectInsuredPayload = async (payload, context) => {
  try {
    const {
      loginProfile,
      projectInsured,
      holderId,
    } = context;
    const isCreation = !projectInsured;
    const piId = payload.projectInsuredId || (projectInsured && projectInsured.ProjectInsuredID);

    const transactionData = {
      performedByUserId: loginProfile && loginProfile.Id,
      performedByDisplay: loginProfile && loginProfile.FirstName + ' ' + loginProfile.LastName,
      holderId,
      projectId: payload.projectId,
      insuredId: payload.insuredId,
      projectInsuredId: piId,
      entityId: String(piId),
      idempotencyKey: TransactionLogger.generateIdempotencyKey(),
      metadata: {
        action: isCreation ? 'CREATE' : 'UPDATE',
        ...(payload.requirementSetId && {
          requirementSetId: payload.requirementSetId,
        }),
        ...(payload.complianceStatusId && {
          complianceStatusId: payload.complianceStatusId,
        }),
        ...(payload.archived && {
          archived: payload.archived,
        }),
      },
    };

    return transactionData;
  } catch (error) {
    console.error('Error mapping project insured payload:', error);
    throw error;
  }
};

export const logProjectInsuredTransaction = async (transactionData, action) => {
  try {
    if (action === 'CREATE') {
      return await TransactionLogger.logProjectInsuredCreation(transactionData);
    } else if (action === 'UPDATE') {
      return await TransactionLogger.logProjectInsuredUpdate(transactionData);
    } else {
      throw new Error(`Unknown action type: ${action}`);
    }
  } catch (error) {
    console.error('Failed to log project insured transaction:', error);
    throw error;
  }
};

export const processProjectInsuredTransaction = async (payload, context) => {
  try {
    const transactionData = await mapProjectInsuredPayload(payload, context);
    const action = context.projectInsured ? 'UPDATE' : 'CREATE';
    
    return await logProjectInsuredTransaction(transactionData, action);
  } catch (error) {
    console.error('Failed to process project insured transaction:', error);
    return false;
  }
};

export const processProjectInsuredStatusTransaction = async (payload, context) => {
  try {
    const transactionData = await mapProjectInsuredPayload(payload, context);
    transactionData.entityTypeCode = ENTITY_TYPE_PROJECT_INSURED;

    if (payload.archived === 1) {
      return await TransactionLogger.logArchive(transactionData);
    } else if (payload.archived === 0) {
      return await TransactionLogger.logUnarchive(transactionData);
    } else {
      throw new Error(`Unknown archived value: ${context.archived}`);
    }
  } catch (error) {
    console.error('Failed to log project insured transaction status:', error);
    throw error;
  }
};

export default {
  mapProjectInsuredPayload,
  logProjectInsuredTransaction,
  processProjectInsuredTransaction,
  processProjectInsuredStatusTransaction,
};
